import API from "@/utils/input-output/api/index";
import constants from "./constants"

export default {
  namespaced: true,
  state: {
    fetchPartnerDetails: false,
    partner: {},
    basicInfo: {},
    isBasicInfoLoading: false,
    esignAgreement: {},
    isEsignAgreementLoading: false,
    editRequests: [],
    flags: [],
    sectionsToBeRefetched: [],
    editRequestsErrors: {},
  },
  mutations: {
    SET_FETCH_PARTNER_DETAILS(state, value) {
      state.fetchPartnerDetails = value
    },
    SET_PARTNER_DETAILS(state, payload) {
      state.partner = {
        ...payload,
        paymentMethod: payload.paymentInfo.paymentMethod,
      };
    },
    SET_BASIC_INFO(state, payload) {
      state.basicInfo = payload
    },
    SET_IS_BASIC_INFO_LOADING(state, payload) {
      state.isBasicInfoLoading = payload
    },
    SET_EDIT_REQUESTS(state, data) {
      state.editRequests = data
    },
    SET_FLAGS(state, data) {
      state.flags = data
    },

    UPDATE_PARTNER_IMG(state, url) {
      state.partner.pictureUrl = url;
    },

    SET_ESIGN_AGREEMENT_DETAILS(state, data) {
      state.esignAgreement = data
    },
    SET_IS_ESIGN_AGREEMENT_LOADING(state, data) {
      state.isEsignAgreementLoading = data
    },
    SET_SECTIONS_TO_BE_REFETCHED(state, sections) {
      state.sectionsToBeRefetched = sections
    },
    SET_EDIT_REQUESTS_ERRORS(state, errors) {
      state.editRequestsErrors = errors
    },
  },

  actions: {
    setFetchPartnerDetails({ commit }, value) {
      commit("SET_FETCH_PARTNER_DETAILS", value)
    },

    updatePartnerAvatar({ commit }, url) {
      commit("UPDATE_PARTNER_IMG", url)
    },

    requestChangeAction(_, {
      id,
      data,
      requestId,
    }) {
      return API({
        url: constants.requestChangeAction({ partnerId: id }),
        method: "post",
        data,
        requestId,
      })
    },

    getPartnerBasicInfo({
      commit,
      dispatch,
    }, {
      partnerId,
      isPartner,
    }) {
      return new Promise((resolve, reject) => {
        API({
          url: constants.partnerDetails({
            partnerId,
            isPartner,
          }),
          method: "GET",
          requestId: "fetchPartnerDetails",
        })
          .then(({ data }) => {
            commit("SET_PARTNER_DETAILS", data.payload.data)
            resolve(data.payload.data)
            /**
             * to avoid calling fetch user API after the partner updates his/her profile picture,
             * just to update teh profile pic in the profile dropdown
             */
            if (isPartner) {
              dispatch("User/updateUserAvatar", { avatarUrl: data.payload.data.pictureUrl }, { root: true })
            }
          })
          .catch((err) => {
            reject(err)
          });
      })
    },

    getEsignAgreementDetails({ commit }, { partnerID }) {
      commit("SET_IS_ESIGN_AGREEMENT_LOADING", true)
      API({
        url: constants.agreementESignStatus({ partnerID }),
        method: "GET",
        requestId: "fetchPartnerAgreementEsignStatus",
        disableDefaultErrorHandlingAt: [404],
      })
        .then(({ data }) => {
          commit("SET_ESIGN_AGREEMENT_DETAILS", data.payload.data)
          commit("SET_IS_ESIGN_AGREEMENT_LOADING", false)
        });
    },

    getBasicInfo({ commit, state }, { partnerID }) {
      commit("SET_IS_BASIC_INFO_LOADING", true)
      API({
        url: constants.basicInfo({ partnerID: partnerID || state.basicInfo.id }),
        requestId: "fetchPartnerBasicInfo",
      }).then(({ data }) => {
        commit("SET_BASIC_INFO", data.payload.data)
        commit("SET_IS_BASIC_INFO_LOADING", false)
      })
    },

    getEditRequests({
      commit, dispatch, state, rootGetters,
    }, { sectionsToBeRefetched, partnerID } = {}) {
      const isPartner = rootGetters["Authorization/isPartner"]
      API({
        url: constants.getEditRequests({
          isPartner,
          partnerID: partnerID || state.basicInfo.id,
        }),
        requestId: "getEditRequests",
      }).then(({ data }) => {
        commit("SET_EDIT_REQUESTS", data.payload.data)
        if (sectionsToBeRefetched?.length) dispatch("setSectionsToBeRefetched", { sectionsIds: sectionsToBeRefetched })
      })
    },

    getFlags({ commit, state, rootGetters }, { partnerID } = {}) {
      const isPartner = rootGetters["Authorization/isPartner"]

      API({
        url: constants.getFlags({
          isPartner,
          partnerID: partnerID || state.basicInfo.id,
        }),
        requestId: "getFlags",
      }).then(({ data }) => {
        commit("SET_FLAGS", data.payload.data)
      })
    },

    setSectionsToBeRefetched({ commit }, { sectionsIds }) {
      commit("SET_SECTIONS_TO_BE_REFETCHED", sectionsIds)
    },

    setEditRequestsErrors({ commit }, { errors }) {
      commit("SET_EDIT_REQUESTS_ERRORS", errors)
    },

    resetSectionsToBeRefetched({ commit }) {
      commit("SET_SECTIONS_TO_BE_REFETCHED", [])
    },

    resetBasicInfo({ commit }) {
      commit("SET_BASIC_INFO", {})
    },

  },

}
